module.exports = __webpack_public_path__ + "img/Confirm.2a7e16bf.svg";